import { VFC } from 'react'
import { darkgray, white } from 'src/styles/colors'
import { fontWeightBold, fontWeightRegular } from 'src/styles/font'
import {
  CONTACT,
  EDIT_PROFILE,
  MESSAGES,
  NEEDS,
  NOTICES,
  NOTICE_CONFIGURATION,
  RECOMMEND,
} from 'src/utils/routes'
import styled from 'styled-components'

export const Footer: VFC = () => (
  <StyledFooter>
    <Navigation>
      <Column>
        <h3>機能</h3>
        <a href={NEEDS}>決裁者を探す</a>
        <a href={RECOMMEND}>今日のAIピック</a>
        <a href={MESSAGES}>メッセージ</a>
        <a href={NOTICES}>運営からのお知らせ</a>
      </Column>
      <Column>
        <h3>設定</h3>
        <a href={EDIT_PROFILE}>プロフィール編集</a>
        {/* Temporarily hidden - story list editing feature
        <a href={EDIT_STORYLIST}>決裁者ストーリー編集</a>
        */}
        <a href={NOTICE_CONFIGURATION}>通知設定</a>
      </Column>
      <Column>
        <h3>
          <a href={CONTACT}>お問い合わせ</a>
        </h3>
      </Column>
    </Navigation>
    <Copyright>Copyright@ONLY STORY.inc All rights Reserved</Copyright>
  </StyledFooter>
)

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  padding: 35px 0;
  background-color: ${darkgray};
  color: ${white};

  @media screen and (max-width: 560px) {
    display: none;
  }
`

const Navigation = styled.nav`
  display: flex;
  justify-content: center;
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 80px 28px;
  h3 {
    font-size: 19px;
    font-weight: ${fontWeightBold};
    margin-bottom: 40px;
  }
  a {
    :hover {
      text-decoration: underline;
    }
  }
  > a {
    font-size: 15px;
    margin-top: 15px;
    font-weight: ${fontWeightRegular};
  }
  :nth-child(-n + 2) {
    @media screen and (max-width: 960px) {
      display: none;
    }
  }
`

const Copyright = styled.p`
  font-size: 20px;
  font-weight: ${fontWeightBold};
  margin: 20px;
  text-align: center;
`
